<div class="row" style="width: 100%">
    <div class="col-md-6">
        <div class="card card-custom gutter-b card-stretch">
            <div class="card-body">
                <app-reports-data [reportData]="defaultReport" type="Default Reports" (changeIsfavourite)="changeIsfavouriteHandler($event)"></app-reports-data>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card card-custom gutter-b card-stretch">
            <div class="card-body">
                <app-reports-data [reportData]="customReport" type="Custom Reports" (changeIsfavourite)="changeIsfavouriteHandler($event)"></app-reports-data>
            </div>
        </div>
    </div>
</div>
